import * as $ from 'jquery';
import Swiper from 'swiper/js/swiper.min.js';

export class MainSlider {
   constructor() {
      this.$slider = $('#main-block__slider');

      if (this.$slider.length === 0) return false;

      this.init();
   }

   init = () => {
      this.initSlider();

      $(window).on('resize', () => {
         this.$sliderInstance.update();
      })
   };

   initSlider = () => {
      this.$sliderInstance = new Swiper(this.$slider, {
         effect: 'fade',
         fadeEffect: {
            crossFade: true,
         },
         speed: 0,
         loop: true,
         preloadImages: false,
         lazy: false,
         resistance: false,
         slidesPerView: 1,
         spaceBetween: 0,
         autoplay: {
            delay: 4000,
            disableOnInteraction: false,
         }
      });
   };
}
